import styled from "styled-components";

export const BotChatMessageWrapper = styled.div`
  ${(props) => props?.theme?.themeConfig?.chatMessages?.botMessage?.wrapper?.styles}

  .message__link {
    display: inline;
    color: #0000EE;
    cursor: pointer;
    text-decoration: underline;
  }
`
